module.exports = __webpack_public_path__ + "static/media/spiffme_600px.d344fcf1.png";